<template lang="html">
	<div class="succeed" v-show="pageReady">
		<div class="invite_people">
			<div class="header_mod">
				<p class="groupBookingNum"><span>{{buyTogether.view_num}}</span>人已领取课程</p>
				<p class="notice_mod" @click="getNotice">
					<img src="../../assets/image/course/notice.png" alt="">
					<span>拼单须知</span>
				</p>
			</div>
			
			<div class="course_particulars">
				<div class="course_details">
					<img :src="buyTogether.cover" alt="" class="cover">
					<div class="details_con">
						<p class="details_title">{{buyTogether.title}}</p>
						<p class="details_text">{{buyTogether.number}}人团</p>
						<div class="details_price">
							<p class="original_prices">
								<img :src="buyTogether.course_teacher.avatar" alt="">
								<span>{{buyTogether.course_teacher.username}}</span>
							</p>
							<p class="current_price">拼团价：￥{{buyTogether.price}}</p>
						</div>
					</div>
				</div>
			</div>

			<div class="invite_text">
				<p>恭喜拼团成功</p>
				<img src="../../assets/image/course/succeed.png" alt="">
			</div>

			<div class="joinPeople">
				<p class="joinTexe">
					已成功邀请参团<span>{{buyTogether.number}}</span>名
				</p>
				
				<div class="planMod">
					<div class="progressBar" :class="10 >= 100 ? 'nobg' : ''">
						<!-- 10为展示的进度，100为总的进度数量 -->
						<div :style="{width: `${(num / 100).toFixed(2) * 100}%` }" class="progressPlam">
							<span class="progressBtn">{{buyTogether.number - buyTogether.remain_num}}名</span>
						</div>
					</div>
				</div>
				
				<div v-for="(img, index) in joinUser" :key="index" class="multiple">
					<div class="joinTitle">
						<img src="../../assets/image/course/succeed.png" alt="" class="header">
						<p v-if="index == 0">团长</p>
						<p v-else>好友{{index}}</p>
					</div>
					<p class="joinPhone">{{img.phone}}</p>
					<p class="joinType">参团成功</p>
				</div>
			</div>

			<div class="invite_join">
				<p class="join_btn">
					去电巢学课
					<WxOpenTag ref="wxopentag" :extinfo="'class/detail?id=' + buyTogether.course_id"/>
				</p>
			</div>
			
			<div class="hint">
				<p class="hintText">请使用当前拼团手机号 <span>{{user_account}}</span></p>
				<p class="hintText">通过<span>短信验证登录</span>方式登录<span>电巢APP</span></p>
				<p class="user_account_number">在 <span>我的-订单-已完成中</span> 查找当前拼团订单</p>
			</div>
		</div>
		
		<div class="related_recommendation" v-if="buyTogetherList.length > 0">
			<div class="add_teacher_title">
				<div class="child_title">
					<img src="../../assets/image/course/vertical_icon.png" alt="" class="vertical">
					<p>推荐拼团课</p>
				</div>
				<p class="bayList" @click="bayList">更多> </p>
			</div>
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(a, index) in buyTogetherList" :key="index">
						<div class="promote_content">
							<img :src="a.cover" alt="" class="related_cover">
							<div class="related_details_con">
								<p class="details_title">{{a.title}}</p>
								<div class="details_money">
									<p>{{a.number}}人团</p>
									<p class="original_price"><s>￥{{a.orign_price}}</s><span>拼团价￥{{a.price}}</span></p>
								</div>
								<div class="teacherText">
									<div class="allTeacher">
										<div v-for="(b, index) in a.teacher" :key="index">
											<img :src="b.avatar" alt="" class="teacherImg">
										</div>
									</div>
									<p class="allTeacherName">
										<span class="teacherName" v-for="(c, index) in a.teacher" :key="index">{{c.username}}</span>
									</p>
								</div>
							</div>
						</div>
						<div class="purchase_btn" @click="getParticulars(a.id)">
							<p>发起拼团</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="call_app">
			<div class="add_teacher_title">
				<img src="../../assets/image/course/vertical_icon.png" alt="" class="vertical">
				<p>添加专属老师，开通更多免费课程</p>
			</div>
			<div class="wx_ma">
				<img src="../../assets/image/course/erweima.png" alt="" class="ma_img">
				<p class="ma_text">长按识别添加</p>
				<div class="safety">
					<img src="../../assets/image/course/safety_icon.png" alt="">
					<p>已通过安全认证，可放心使用</p>
				</div>
			</div>
		</div>
		<div class="about_app">
			<img src="../../assets/image/course/logo.png" alt="">
			<p>电子工程师的孵化巢</p>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper/swiper-bundle.min.js'
	import 'swiper/swiper-bundle.min.css'
	import utils from '@/utils/utils';
	import Storage from '@/utils/localStore'
	import WxOpenTag from '@/components/WxOpenTag'
	import {pagebase, appId} from '@/utils/http'
	import WxShare from '@/utils/wxshare'

	let userPro = {}

	export default {
		components: {
			WxOpenTag,
		},
		data() {
			return {
				pageReady: false,
				tid: this.$route.query.tid || '',
				tcode: this.$route.query.tcode || '',
				buyTogether: {
					course_teacher: {},
				},
				joinUser: [],
				cur: 0,
				user_account: '',
				num: 0,
				buyTogetherList: {},
			}
		},
		created() {
			this.checkUserPro()
		},
		mounted() {
			if(utils.browserChecker.isWx()){
				this.$refs.wxopentag.register()
			}
		},
		methods: {
			checkUserPro() {
				let user = Storage.getItem('pink_user_pro')
				if (user) {
					userPro = user
					this.init()
					this.pageReady = true
				} else {
					let code = utils.getQuery('code', location.href)
					if (!code) {
						let open = encodeURIComponent(location.href)
						/*是否是在微信中打开在跳这个页面的时候这里会判断*/
						let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${open}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
						window.location.href = url
					} else {
						this.$http.get('/user/wxUserInfo', {
							params: {
								code: code,
								appid: appId,
								together_code: this.tcode,
							}
						}).then(res => {
							if (res.code >= 0) {
								userPro = res.data
								this.init()
								/*用户授权之后 -> 拿到用户信息 才显示页面*/
								this.pageReady = true
							} else if (res.code == -888) {
								/*当code已经被使用过时，重新获取当前页面的code*/
								let curl = location.origin + location.pathname + location.hash
								let open = encodeURIComponent(curl)
								let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${open}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
								location.replace(url)
							} else {
								utils.showMessage('用户授权失败')
							}
						})
					}
				}
			},
			init() {
				this.getWx = new WxShare();
				this.getCourseInfo();
			},
			getCourseInfo() {
				this.$http.get('/course/buyTogetherResult', {
					params: {
						id: this.tid,
						uid: userPro.uid || '',
						token: userPro.token || ''
					}
				}).then(res => {
					if (res.code >= 0) {
						let data = res.data
						this.buyTogether = res.data.buy_together_info;
						this.joinUserList = data.buy_together_info.join_user;
						
						if (this.joinUserList.length != 0) {
							this.joinUserList.forEach((user, index) => {
								this.joinUser[index] = user
							})
							this.joinUser = [...this.joinUser]
						}
						this.getBuyTogetherList();
						this.getNumber();
						this.getWx.share({
							title: this.buyTogether.title,
							desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
							link: pagebase + '/#/course?tid=' + this.tid,
							imgUrl: this.buyTogether.cover,
						});
						document.title = res.data.buy_together_info.title;
						this.user_account = res.data.user_account;
						this.$refs.topVideoWrapper && (this.$refs.topVideoWrapper.style.backgroundImage = `url('${res.data.course_info.pic}')`);
					}
				})
			},
			// 进度条
			getNumber() {
				// 拼团总人数
				var a = this.buyTogether.number;
				// 已拼团人数
				var b = this.buyTogether.number - this.buyTogether.remain_num
				this.num = 100/a*b;
			},
			getParticulars(tid) {
				this.$router.push({
					path: '/course',
					query: {
						tid: tid,
					}
				})
			},
			getBuyTogetherList() {
				this.$http.get('/course/buyTogetherList', {
					params: {
						id: this.tid,
						uid: userPro.uid || '',
						token: userPro.token || '',
					}
				}).then(res => {
					if (res.code >= 0) {
						this.buyTogetherList = res.data;
						this.$nextTick(function() {
							this.getSwiper();
						}, 0);
					}
				})
			},
			getNotice(){
				this.$router.replace({
					path: '/notice',
				})
			},
			bayList(){
				this.$router.push({
					path: '/bayList',
				})
			},
			getSwiper() {
				new Swiper('.swiper-container', {
					slidesPerView: "auto",
					spaceBetween: 10,
					observer: true,
					observeParents: true,
				});
			}, 
		},
	}
</script>

<style lang="css" scoped>
	/* 通用 */
	.succeed {
		background-color: #F7F8F8;
	}
	
	.header_mod{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 1rem;
	}
	
	.groupBookingNum{
		box-sizing: border-box;
		margin-top: 1rem;
		display: inline-block;
		background-color: #FEF9F0;
		font-size: 1rem;
		border-radius: 2rem;
	}
	
	.groupBookingNum span{
		font-size: 1.2rem;
		color: #E57701;
	}
	
	.notice_mod{
		display: flex;
		align-items: center;
	}
	
	.notice_mod img{
		width: 1.6rem;
		height: 1.6rem;
		margin-top: .1rem;
		margin-right: .2rem;
		flex-shrink: 0;
	}
	
	.notice_mod span{
		font-size: 1.2rem;
		color: #606972;
		border-bottom: .1rem solid #606972;
	}

	.add_teacher_title {
		display: flex;
		align-items: center;
		font-size: 1.8rem;
		padding-top: 1.4rem;
	}

	.vertical {
		height: 1.8rem;
		margin-right: .6rem;
	}

	.invite_people {
		box-sizing: border-box;
		background-color: #FFFFFF;
		padding: 0 1.5rem 1.6rem 1.5rem;
	}

	/* 课程详情 */
	.course_particulars {
		box-sizing: border-box;
	}

	.course_details {
		margin-top: 1.4rem;
		box-sizing: border-box;
		display: flex;
	}

	.cover {
		width: 13.7rem;
		height: 8.6rem;
		object-fit: cover;
		border-radius: .5rem;
		flex-shrink: 0;
	}

	.details_con {
		margin-left: 1rem;
		width: 100%;
	}

	.details_title {
		height: 4rem;
		font-size: 1.4rem;
		font-weight: bolder;
		color: #1D2023;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		word-break: break-word;
	}

	.details_money{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1.2rem;
		color: #808598;
	}
	
	.details_text {
		font-size: 1.2rem;
		color: #606972;
		margin-top: .45rem;
		margin-right: 2rem;
		text-align: end;
	}

	.details_price {
		display: flex;
		justify-content: space-between;
		margin-top: .85rem;
	}
	
	.original_prices {
		width: 12rem;
		font-size: 1.2rem;
		color: #808598;
		display: flex;
		align-items: center;
	}
	
	.original_prices img {
		height: 2rem;
		border-radius: 50%;
		margin-right: .4rem;
	}
	
	.original_price {
		font-size: 1.2rem;
		color: #808598;
		display: flex;
		align-items: center;
	}
	
	.original_price s{
		margin-right: .5rem;
	}
	
	.original_price span{
		color: #E6001F;
	}
	
	.teacherText {
		height: 2rem;
		display: flex;
		align-items: center;
	}
	
	.allTeacher {
		display: flex;
		padding-left: .5rem;
	}
	
	.teacherImg {
		margin-left: -.5rem;
	}
	
	.teacherImg {
		width: 2rem;
		height: 2rem;
		border-radius: 50%;
		object-fit: cover;
	}
	
	.allTeacherName {
		height: 2.4rem;
		line-height: 2.4rem;
		margin-top: -.6rem;
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		word-wrap: break-word;
		word-break: break-word;
	}
	
	.teacherName {
		font-size: 1.2rem;
		color: #808598;
		margin-left: .4rem;
	}

	.current_price {
		font-size: 1.2rem;
		color: #E6001F;
	}

	.time_title {
		margin-top: 1.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.8rem;
	}

	.time_title img {
		height: 1rem;
		margin: 0 1rem;
	}

	.time_con {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.6rem;
		margin-top: 1.4rem;
	}

	.time_num {
		width: 2.4rem;
		height: 2.4rem;
		line-height: 2.4rem;
		text-align: center;
		border-radius: .5rem;
		color: #FFFFFF;
		background-color: #E50202;
	}

	.time_texe {
		color: #E50101;
		margin: 0 .7rem;
	}

	.invite_text {
		margin-top: 3rem;
		text-align: center;
		font-size: 1.8rem;
		font-weight: bolder;
		color: #1D2023;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.invite_text img {
		height: 2.2rem;
		margin-left: .5rem;
	}

	.user_header {
		margin-top: 1.4rem;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
	}

	.img_show {
		display: flex;
		align-items: center;
	}
	
	.joinPeople{
		box-sizing: border-box;
		background-color: #F5F6F8;
		margin: 0 1.5rem;
		margin-top: 1rem;
		border-radius: 1rem;
		padding: 1.4rem 2rem;
	}
	
	.joinTexe{
		font-size: 1.6rem;
		color: #1D2023;
		font-weight: 600;
	}
	
	.joinTexe span{
		font-size: 2rem;
		color: #E6001F;
	}
	
	.joinTitle{
		width: 6.6rem;
		display: flex;
		align-items: center;
		font-size: 1.2rem;
		color: #606972;
	}
	
	.joinTitle img{
		width: 1.6rem;
		height: 1.6rem;
		margin-right: 1rem;
	}
	
	.joinPhone{
		font-size: 1.2rem;
		color: #1D2023;
	}
	
	.joinType{
		font-size: 1.2rem;
		color: #1D2023;
	}
	
	/* 进度条 */
	.planMod {
		box-sizing: border-box;
		padding: 1.5rem 0;
	}
	
	.progressBar {
		box-sizing: border-box;
		position: relative;
		width: 100%;
		height: .6rem;
		background: #E8EAEC;
		border-radius: 5rem;
	}
	
	.progressPlam {
		position: absolute;
		top: 0;
		left: 0;
		height: .6rem;
		border-radius: 5rem;
		background: linear-gradient(to right, #FBC0D5, #FF99F0);
		padding-right: 3.6rem;
		box-sizing: border-box;
	}
	
	.progressBtn {
		box-sizing: border-box;
		position: absolute;
		right: 0;
		top: -.75rem;
		z-index: 10;
		display: block;
		width: 3.6rem;
		height: 2rem;
		line-height: 2rem;
		text-align: center;
		border-radius: 1em;
		background: #F95241;
		font-size: 1.2rem;
		color: #FFFFFF;
	}
	
	.multiple{
		margin-top: 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 1rem;
	}
	.multiple img{
		margin-left: -1.5rem;
		border: .1rem solid #FFFFFF;
	}

	.header {
		width: 4.8rem;
		height: 4.8rem;
		border-radius: 50%;
		object-fit: cover;
	}

	.link {
		height: .4rem;
		margin: 0 2.5rem;
	}

	.invite_join {
		margin-top: 2.8rem;
		display: flex;
		justify-content: center;
	}

	.join_btn {
		position: relative;
		width: 32.5rem;
		height: 4.5rem;
		line-height: 4.5rem;
		text-align: center;
		font-size: 1.8rem;
		color: #FFFFFF;
		background-color: #E6001F;
		border-radius: 2.25rem;
	}

	.hint {
		box-sizing: border-box;
		height: 14rem;
		background-color: #FFFFFF;
		margin-top: 3.8rem;
		padding: 2rem 0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1);
		border-radius: 1rem;
	}
	
	.hintText{
		font-size: 1.4rem;
		color: #1D2023;
	}
	
	.hintText span{
		font-size: 1.6rem;
		color: #E6001F;
		margin: 0 .5rem;
		font-weight: 600;
	}

	.succeed_text {
		box-sizing: border-box;
		height: 5.8rem;
		text-align: center;
		background: url("../../assets/image/course/back_1.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		object-fit: cover;
		font-size: 1.4rem;
	}

	.succeed_text p {
		padding-top: 1rem;
	}

	.user_account_number {
		margin-top: 1.5rem;
		width: 30rem;
		height: 3rem;
		line-height: 3rem;
		font-size: 1.2rem;
		color: #808598;
		background-color: #F2F3F6;
		border-radius: 1.5rem;
		text-align: center;
	}
	
	.user_account_number span{
		color: #1D2023;
	}
	
	/* 相关推荐 */
	.related_recommendation {
		box-sizing: border-box;
		margin-top: 1rem;
		background-color: #FFFFFF;
		overflow: hidden;
		padding: 1.4rem 0;
	}
	
	.add_teacher_title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 1.8rem;
		padding: 0 1.5rem;
	}
	
	.vertical {
		height: 1.8rem;
		margin-right: .6rem;
	}
	
	.bayList{
		font-size: 1rem;
		color: #606972;
	}
	
	.child_title{
		width: 12rem;
		display: flex;
		align-items: center;
	}
	
	.swiper-container {
		box-sizing: border-box;
		padding: 2rem;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.swiper-wrapper {
		display: flex;
		justify-content: flex-start;
	}
	
	.swiper-slide {
		box-sizing: border-box;
		width: 32rem;
		height: 15.8rem;
		background-color: #FFFFFF;
		border-radius: .8rem;
		box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1);
		padding-top: .3rem;
	}
	
	.promote_content {
		box-sizing: content-box;
		margin-right: 1rem;
		padding: 1.2rem 0;
		display: flex;
	}
	
	.related_cover {
		width: 13.7rem;
		height: 8.4rem;
		object-fit: cover;
		border-radius: .5rem;
		margin-left: 1rem;
		flex-shrink: 0;
	}
	
	.related_details_con {
		margin-left: 1rem;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.purchase_btn {
		display: flex;
		justify-content: center;
	}
	
	.purchase_btn p {
		width: 18rem;
		height: 3.2rem;
		line-height: 3.2rem;
		text-align: center;
		font-size: 1.4rem;
		color: #FFFFFF;
		background: linear-gradient(to right, #FE405A, #E50101);
		border-radius: 1.6rem;
	}

	.call_app {
		margin-top: 1rem;
		box-sizing: border-box;
		padding: 0 1.5rem;

		background-color: #FFFFFF;
	}

	.wx_ma {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 3.3rem;
	}

	.ma_img {
		height: 9rem;
		margin-top: 2.2rem;
	}

	.ma_text {
		font-size: 1.4rem;
		color: #606972;
	}

	.safety {
		width: 25rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 1.2rem;
		color: #489F2F;
		font-size: 1.4rem;
	}

	.safety img {
		height: 1.8rem;
	}

	.about_app {
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		padding: 1rem 0;
		background-color: #FFFFFF;
		box-shadow: 0 0 .5rem rgba(3, 3, 3, 0.1);
	}

	.about_app img {
		height: 2.6rem;
	}

	.about_app p {
		margin-left: 1rem;
		font-size: 1.6rem;
		color: #1D2023;
	}
</style>
